import { render, staticRenderFns } from "./InfoGoodsReview.vue?vue&type=template&id=0e99add7&scoped=true&"
import script from "./InfoGoodsReview.vue?vue&type=script&lang=js&"
export * from "./InfoGoodsReview.vue?vue&type=script&lang=js&"
import style0 from "./InfoGoodsReview.vue?vue&type=style&index=0&id=0e99add7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99add7",
  null
  
)

export default component.exports